// This file is generated by pnpm icons:generate. Do not edit.

import {Bell2_Stroke2_Corner0_Rounded as CanonicalBell2_Stroke2_Corner0_Rounded} from './Bell'
import {Bell2Off_Filled_Corner0_Rounded as CanonicalBell2Off_Filled_Corner0_Rounded} from './Bell'
import {Bell2Off_Stroke2_Corner0_Rounded as CanonicalBell2Off_Stroke2_Corner0_Rounded} from './Bell'

/** @deprecated Import Bell2_Stroke2_Corner0_Rounded from `#/components/icons/Bell` instead. */
export const Bell2_Stroke2_Corner0_Rounded =
  CanonicalBell2_Stroke2_Corner0_Rounded

/** @deprecated Import Bell2Off_Filled_Corner0_Rounded from `#/components/icons/Bell` instead. */
export const Bell2Off_Filled_Corner0_Rounded =
  CanonicalBell2Off_Filled_Corner0_Rounded

/** @deprecated Import Bell2Off_Stroke2_Corner0_Rounded from `#/components/icons/Bell` instead. */
export const Bell2Off_Stroke2_Corner0_Rounded =
  CanonicalBell2Off_Stroke2_Corner0_Rounded
